export default __webpack_public_path__ + "static/thumbBlank-952a5b7ad4d9c47fecd81f3ad3faf739.jpg";